import { apiFetch } from "@/lib/api";
import type { LaborOperatorDisplay } from "@/lib/labor/laborOperatorPresence";

export interface ClampQcJobOperator extends LaborOperatorDisplay {
  jobSlug: string;
}

export const clampQcActiveJobOperatorsQueryKey = ["clamp-qc", "labor", "active-job-operators"] as const;

export const CLAMP_QC_JOB_PRESENCE_INTERVAL_MS = 15_000;

export async function fetchClampQcActiveJobOperators(): Promise<ClampQcJobOperator[]> {
  const data = await apiFetch<{ operators: ClampQcJobOperator[] }>("/api/labor/clampqc/active-job-operators", {
    cache: "no-store",
  });
  return data.operators;
}

export function normalizeClampQcJobSlug(slug: string): string {
  return slug.trim().toLowerCase().replace(/^\/+|\/+$/g, "").replace(/\s+/g, "-");
}

export function filterClampQcOperatorsForJobSlug(
  operators: ClampQcJobOperator[],
  slug: string,
): ClampQcJobOperator[] {
  const normalized = normalizeClampQcJobSlug(slug);
  if (normalized === "") return [];
  return operators.filter((operator) => normalizeClampQcJobSlug(operator.jobSlug) === normalized);
}
